import { GitBranch } from 'lucide-react';
import { registerVizType, getRegisteredVizType } from '@/lib/customVizRegistry';
import { SankeyRenderer } from './SankeyRenderer';
import { SankeyConfigPanel } from './SankeyConfigPanel';

/**
 * Sankey demo plugin. Self-registers on import.
 * Idempotent — safe to import in development with hot-reload.
 */
if (!getRegisteredVizType('sankey')) {
  registerVizType({
    type: 'sankey',
    label: 'Sankey Diagram',
    icon: GitBranch,
    renderer: SankeyRenderer,
    configPanel: SankeyConfigPanel,
    meta: {
      description: 'Flow diagram showing how source values branch into target values. Best for funnel analysis, supply chains, multi-step conversion paths.',
      defaultConfig: {
        nodePadding: 20,
        nodeWidth: 12,
        linkOpacity: 0.4,
        showLabels: true,
      },
      supportsTopN: false,
      supportsPeriodComparison: false,
      supportsDrillThrough: true,
      shelves: ['source', 'target', 'value'],
    },
  });
}
